'use client'

import { useIsUsingBigBlocks } from '@/domain/hooks/useIsUsingBigBlocks'
import { useBigBlocksToggle } from '@/features/swap/logic/useBigBlocksToggle'
import { Switch } from '@/ui/atoms/switch/Switch'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'
import { Loader2 } from 'lucide-react'

interface BigBlocksBannerProps {
  className?: string
}

export function BigBlocksBanner({ className }: BigBlocksBannerProps) {
  const { data: isUsingBigBlocks, isLoading: isLoadingStatus } = useIsUsingBigBlocks()
  const { setIsUsingBigBlocks, isLoading: isToggling, error } = useBigBlocksToggle()

  if (isLoadingStatus) return null

  return (
    <div className={cn('rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2', className)}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <span className="text-muted-foreground text-sm">Using big blocks</span>
          <Info size={14}>
            Some transactions require higher gas limit via Big Blocks, a feature on Hyperliquid EVM. Big Block
            transactions will take ~1 minute to confirm. Enable Big Blocks, then switch back to small blocks when your
            transaction is complete.
          </Info>
        </div>
        <div className="flex items-center gap-2">
          {isToggling && <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />}
          <Switch
            checked={!!isUsingBigBlocks}
            onCheckedChange={(checked) => { setIsUsingBigBlocks(checked).catch(() => {}) }}
            disabled={isToggling}
          />
        </div>
      </div>
      {error && <p className="mt-1.5 truncate text-red-400 text-xs">{error}</p>}
    </div>
  )
}
